import React from "react";
import { Link } from "react-router-dom";
import returnYear from "../utils/GetYear";

const INSTAGRAM_URL = "https://www.instagram.com/tyronelayne/";
const TIKTOK_URL = "https://www.tiktok.com/@tyronelayne";

function Footer() {
  return (
    <footer className='siteFooter'>
      <div className='siteFooterLinks'>
        <a
          className='siteFooterLink'
          href={INSTAGRAM_URL}
          target='_blank'
          rel='noopener noreferrer'
          aria-label="Tyrone Layne on Instagram"
        >
          Instagram
        </a>
        <span className='siteFooterSeparator' aria-hidden='true'>·</span>
        <a
          className='siteFooterLink'
          href={TIKTOK_URL}
          target='_blank'
          rel='noopener noreferrer'
          aria-label="Tyrone Layne on TikTok"
        >
          TikTok
        </a>
        <span className='siteFooterSeparator' aria-hidden='true'>·</span>
        <Link
          className='siteFooterLink'
          to='/newsletter'
          aria-label="Subscribe to Tyrone Layne's mailing list"
        >
          Mailing List
        </Link>
        <span className='siteFooterSeparator' aria-hidden='true'>·</span>
        <Link
          className='siteFooterLink'
          to='/returns-policy'
          aria-label='Returns & Shipping Policy'
        >
          Returns & Shipping
        </Link>
      </div>
      <div className='siteFooterCopyright'>
        © {returnYear()} Tyrone Layne
      </div>
    </footer>
  );
}

export default Footer;
